// src/pages/Login.jsx
import React, { useState } from 'react';
import { login } from '../api/api';
import { useAuth } from '../auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import "./Login.scss";

export default function Login() {
    const { loginUser } = useAuth();
    const [form, setForm] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const navigate = useNavigate();
    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        try {
            const data = await login(form.email, form.password);
            await loginUser(data.token);
            navigate('/');
        } catch (err) {
            setError(err.message || 'Ошибка входа');
        }
    }

    return (
        <div className="login-page">
            <form className="login-form" onSubmit={handleSubmit}>
                <h2>Вход в админку</h2>
                <input
                    type="text"
                    placeholder="Логин или телефон"
                    value={form.email}
                    onChange={e => setForm({ ...form, email: e.target.value })}
                    required
                />
                <input
                    type="password"
                    placeholder="Пароль"
                    value={form.password}
                    onChange={e => setForm({ ...form, password: e.target.value })}
                    required
                />
                {error && <div className="error">{error}</div>}
                <button type="submit">Войти</button>
            </form>
        </div>
    );
}
